import { useEffect, useState } from "react";
import useDataBean from "../../../../../../../core/services/dataBean/useDataBean";
import { toast } from "react-toastify";
import { BasicTable } from "../../../../../../theme/Component/BasicTable";
import { _AssetItemHistory, _FixedAssetItem } from "../../../../../../../core/services/dataBean/EntityCatalogVdos";
import { _AssignedMaintenanceType, _single } from "../../../../../../../core/services/dataBean/EntityCatalog";

interface Props {
    idItem: number;
}

export const WorkMaintenanceOrderByItem = ({ idItem }: Props) => {
    const { instance, lista, bean, setBean, setLista } = useDataBean(_FixedAssetItem)

    useEffect(() => {
        getLista();
    }, [idItem])

    const getLista = () => {

        instance.getWorkMaintenanceOrderCatalog(idItem).then(
            (resp: any) => {
                setLista(resp);
            }
        ).catch(
            err => { toast.error(err) }
        )
    }

    const head = [
        { title: 'ID', property: 'IDWorkMaintenanceOrder', visible: true },
        { title: 'IDItem', property: 'IDRequestMaintenance', visible: true },
        { title: 'Observaciones', property: 'Observations', visible: true },
        { title: 'Estado', property: 'StateName', visible: true },
        { title: 'Fecha', property: 'Since', visible: true },
    ]


    return (
        <div className="row">
            <div className="col-md-12">
                <BasicTable body={lista} head={head} rowSet={setBean} />
            </div>
        </div>
    )
}